<template>
  <div class="attachmentsContainer">
    <ul class="attachments">
      <li class="attachment" v-for="attachment in attachments" :key="attachment.id">
        <a v-if="attachment.document" :href="'https://teamsapi.gosokal.com/download_link/'+ attachment.id" target="_blank">{{attachment.name}} {{attachment.size}}</a>
        <a v-if="attachment.image" :href="attachment.url" target="_blank">{{attachment.name}} {{attachment.size}}</a>
        <a v-if="controls" class="close" href="#" @click="deleteAttachment(attachment)"><fa icon="trash"/></a>
      </li>
      <a v-if="attachments.length > 1" :href="'https://teamsapi.gosokal.com/download_all_link/' + downloadAllLink()" target="_blank">Download All</a>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'Attachments',
  props: ['attachments', 'controls'],
  methods: {
    deleteAttachment (attachment) {
      this.sendDeleteRequest(attachment.id)
    },

    sendDeleteRequest (id) {
      this.$http.delete('/uploads/' + id)
        .then(response => {
          let index = this.attachments.findIndex(attachment => attachment.id === id)
          this.attachments.splice(index, 1)
        })
        .catch(e => {
          console.error(e)
        })
    },
    downloadAllLink () {
      return this.attachments.map(attachment => attachment.id).join(',')
    }
  }
}
</script>
<style scoped>
  .attachments {
    display: inline;
    list-style: none;
    margin-left: auto;
    margin-right: auto;
    padding-left: 0;
   }
  .attachment {
    background: #fff;
    border-radius: 12px;
    border: 1px solid #dadada;
    display: inline-block;
    line-height: 1;
    margin: 8px 4px 8px 0;
    padding: 4px 10px;
    position: relative;
  }
  .attachmentsContainer {
    text-align: left
  }
  .close {
    color: #93a1af;
    font-size: 14px;
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Attachments.vue